import React from 'react';

const PreviousLocationContext = React.createContext();

export default PreviousLocationContext;
